import axios from "axios";

const getInactiveDealerTrending = ({
  country,
  city_id,
  branch_uuid,
  period,
  start_date,
  end_date,
  url
}) => {
  let city = city_id;
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        country,
        city,
        branch_uuid,
        period,
        start_date,
        end_date,
      })
      .then((response) => resolve(response.data))
      .catch((error) => {
        if (error?.response?.data) {
          reject(error.response.data);
        } else {
          reject(error);
        }
      });
  });
};

export default getInactiveDealerTrending;
